import { render, staticRenderFns } from "./CommonUploadComponent.vue?vue&type=template&id=0d6630e9"
import script from "./CommonUploadComponent.vue?vue&type=script&lang=js"
export * from "./CommonUploadComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonUploadComponent.vue?vue&type=style&index=0&id=0d6630e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports